import jQuery from "jquery";
import { imagesSlider } from "./sliders";
import triggerContactOverlay from "./contact-btn";

imagesSlider();
triggerContactOverlay();

jQuery(document).ready(function ($) {
  function addFacetRefreshAnimation() {
    $(document).on("facetwp-refresh", function () {
      if (FWP.loaded) {
        $(".facetwp-template").prepend('<div class="facets-loading"></div>');
      }
    });
  }

  addFacetRefreshAnimation();

  function triggerCategories() {
    $(".category-list").hide();

    var $categories = $(".js-open-cat");
    $categories.on("click", function (e) {
      e.preventDefault();
      $(".category-list").slideToggle();
      $(this).toggleClass("open");
    });
  }

  function toggleChildren() {
    var children = $(".children > li > .children");

    children.hide();

    children.before('<div class="cat-toggle"></div>');

    $(".cat-toggle").on("click", function (e) {
      e.preventDefault();
      $(this).next(children).slideToggle();

      $(this).toggleClass("open");
    });
  }

  function hideChildren() {
    var children = $(".children");

    children.hide();
  }

  if ($(window).width() < 768) {
    triggerCategories();
    hideChildren();
  }

  if ($(window).width() > 768) {
    toggleChildren();
  }

  function getCookie(name) {
    const v = document.cookie.match(`(^|;) ?${name}=([^;]*)(;|$)`);
    return v ? v[2] : null;
  }

  function setCookie(name, value, days) {
    const d = new Date();
    d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
    document.cookie = `${name}=${value};path=/;expires=${d.toGMTString()}`;
  }

  window.onload = function cookieC() {
    if (getCookie("cookieConsent") !== "on") {
      $(".c-cookie-consent").show();
    }
  };

  $("[data-close-cookie]").on("click", (e) => {
    e.preventDefault();
    setCookie("cookieConsent", "on", 14);
    $(".c-cookie-consent").remove();
  });
});

function openMenu() {
  function init() {
    const hamburger = document.querySelector(".hamburger");
    const menu = document.querySelector(".mobile-menu");

    hamburger.addEventListener("click", () => {
      hamburger.classList.toggle("is-active");
      menu.classList.toggle("is-open");
      document.body.classList.toggle("mobile-menu-open");
    });
  }

  const isPresent = document.getElementsByClassName("hamburger");
  if (isPresent.length > 0) {
    init();
  }
}

openMenu();
